module.exports = __webpack_public_path__ + "img/phone-screen-fr.a5f4f79d.png";